import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./UtilityList.css";

import TreeView from "../../components/treeView/treeView";
import { TreeViewProvider } from "../../context/treeViewContext";

import MergedTable from "./tab01/MergedTable";
import Tab02 from "./tab02/tab02";
import Tab03 from "./tab03/tab03";
import Tab04 from "./tab04/tab04";
import Tab05 from "./tab05/tab05";

const UtilityList = () => {
    const treeRef = useRef(null);
    const navigate = useNavigate();

    const [activeTab, setActiveTab] = useState(() => {
        return localStorage.getItem("activeTab") || "01";
    });

    const [selectedRow, setSelectedRow] = useState(null); // selectedRowを親コンポーネントで管理

    useEffect(() => {
        localStorage.setItem("activeTab", activeTab);
    }, [activeTab]);

    const handleEditClick = () => {
        if (!selectedRow) return;
        navigate(`/EditMaster/${selectedRow.masterID}`, {
        state: {
            edit: true,
            data: selectedRow,
            category: selectedRow.colorClass,
            openModal: true,
            initialTab: "01"
        }
        });
    };

    //タブ切り替え時にselectedRowをnullにする。
    const handleTabChange = (tabId) => {
        setActiveTab(tabId);
        setSelectedRow(null); // 🔁タブ切り替えでリセット
      };
      

    // tabs 定義を修正（selectedRow / setSelectedRow を全タブに渡す）
    const tabs = [
        { id: "01", label: "原動全体", component: <MergedTable selectedRow={selectedRow} setSelectedRow={setSelectedRow} /> , category: "default"},
        { id: "02", label: "電気詳細", component: <Tab02 selectedRow={selectedRow} setSelectedRow={setSelectedRow} />, category: "electric"},
        { id: "03", label: "ネットワーク詳細", component: <Tab03 selectedRow={selectedRow} setSelectedRow={setSelectedRow} />, category: "network" },
        { id: "04", label: "給排気詳細", component: <Tab04 selectedRow={selectedRow} setSelectedRow={setSelectedRow} />, category: "air"},
        { id: "05", label: "給排水詳細", component: <Tab05 selectedRow={selectedRow} setSelectedRow={setSelectedRow} />, category: "water" },
    ];
  

    return (
        <TreeViewProvider>
            <div className="utility-container">
                <div className="leftContainer">
                    <TreeView className="treeView" />
                </div>

                <div className="rightContainer">
                    <ul className="tab__menu">
                        {tabs.map((tab) => (
                            <li
                                key={tab.id}
                                className={`tab__menu-item ${activeTab === tab.id ? "is-active" : ""}`}
                                onClick={() => handleTabChange(tab.id)}
                            >
                                {tab.label}
                            </li>
                        ))}
                    </ul>

                    <div className="tab__panel">
                        <div className="tab-header">
                            <div className="edit-button-wrapper">
                                <button
                                    className="edit-button"
                                    onClick={handleEditClick}
                                    disabled={!selectedRow} // selectedRowがnullの場合、ボタンを無効化
                                >
                                    編集
                                </button>
                            </div>
                        </div>
                        {tabs.map((tab) => (
                            <div
                                key={tab.id}
                                className={`tab__panel-box tab__panel-box0${tab.id} ${activeTab === tab.id ? "is-show" : ""}`}
                            >
                                {activeTab === tab.id && tab.component}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </TreeViewProvider>
    );
};

export default UtilityList;
